var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 900,
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.775 416.887C153.308 425.812 122.32 447.381 101.634 477.541C80.9485 507.702 71.988 544.378 76.4364 580.679C80.8848 616.981 98.436 650.408 125.792 674.681C153.149 698.955 188.427 712.403 225 712.5H637.5C663.976 712.482 690.149 706.857 714.295 695.995C738.44 685.133 760.012 669.28 777.59 649.48C795.167 629.681 808.352 606.383 816.277 581.12C824.201 555.857 826.686 529.203 823.566 502.91C820.447 476.618 811.795 451.285 798.18 428.578C784.564 405.87 766.294 386.304 744.571 371.167C722.849 356.03 698.167 345.664 672.15 340.754C646.133 335.843 619.371 336.497 593.625 342.675L543.75 356.25",
    className: "svgStroke",
    strokeWidth: 75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M593.625 342.674C580.808 291.921 549.172 247.939 505.13 219.646C461.088 191.353 407.935 180.865 356.447 190.308C304.959 199.751 258.988 228.419 227.852 270.499C196.717 312.58 182.747 364.925 188.775 416.924C188.775 416.924 194.512 449.999 206.25 468.749",
    className: "svgStroke",
    strokeWidth: 75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsCloud);
export default __webpack_public_path__ + "static/media/akar-icons_cloud.ba101c9a.svg";
export { ForwardRef as ReactComponent };